export default __webpack_public_path__ + "static/media/back-button-icon.c620199b.svg";